export default "__VITE_ASSET__CQEhZoQJ__"